import { Api } from '@axiom/ui';
import type { Candidate, Education, EducationEdit } from '@axiom/validation';

import { EnvUtil } from '../utils/env-util';

class CandidateDegreesApiClass extends Api {
  constructor() {
    super({
      domain: EnvUtil.apiPortalUrl,
      cookieDomain: EnvUtil.cookieDomain,
    });
  }

  async createEducation(id: Candidate['id'], education: EducationEdit) {
    return super.write<{ data: Education }>({
      endpoint: `/candidates/${id}/degrees`,
      body: education,
      method: 'POST',
    });
  }
}

export const CandidateDegreesApi = new CandidateDegreesApiClass();
